<template>
  <span class="badge bg-danger mx-2">New</span>
</template>
